// assets/js/data_source.js

////////////////////////////////////////////
// Sub-Level Tabs: Bind Bootstrap Tab Events
////////////////////////////////////////////
export function initSubLevelTabs() {
	$(document).on('shown.bs.tab', 'a.nav-link[data-bs-toggle="tab"]', function(e) {
		const $link = $(e.target);
		const subTabId = ($link.attr('href') || '').replace('#','');
		let top = $('.tabs_wrap .single_tab.active').data('tab') || '';
		top = top.replace('#','');
		location.hash = top ? `${top}/${subTabId}` : subTabId;

		// If data-source
		const dsId = $link.data('source_id');
		if (dsId) {
			fetchDataSources($link.attr('href'), dsId);
		}
	});
}

function escapeHtml(text) {
	if (!text) return '';
	return text
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}


/**
 * Build the HTML for one run (log entry).
 * - The first run uses "first-source" styling + a Download button
 * - Subsequent runs use "other-source"
 */
const buildSingleRunHtml = (run, index, data_source_id) => {
	const wrapClass   = (index === 0) ? 'first-source' : 'other-source';
	const downloadBtn = (index === 0)
		? `<a class="btn btn-active download-btn" data-id="${data_source_id}">Download</a>`
		: '';

	// We could also consider run.status if needed
	const eventsHtml = buildEventsHtml(run.events);

	return `
      <div class="source_wrap ${wrapClass}">
        <div class="col1">
          <!-- Display all events in this column (or adapt your layout) -->
          ${eventsHtml}
        </div>
        <div class="col3">
          ${downloadBtn}
        </div>
      </div>
    `;
};


/**
 * If no runs, show a message. Otherwise, build HTML for each run.
 */
const buildLogHtml = (logs, data_source_id) => {
	if (!Array.isArray(logs) || logs.length === 0) {
		return '<div class="no-data">No logs available</div>';
	}
	return logs
		.map((run, idx) => buildSingleRunHtml(run, idx, data_source_id))
		.join('');
};



/**
 * Build HTML for an array of events in a single run.
 */
const buildEventsHtml = (events) => {
	if (!Array.isArray(events) || events.length === 0) {
		return '<div class="no-events">No events found</div>';
	}

	return events
		.map((ev) => {
			let statusClass, statusText;
			if (ev.status_id === 1) {
				statusClass = 'success';
				statusText  = 'Success';
			} else if (ev.status_id === 2) {
				statusClass = 'running';
				statusText  = 'Running';
			} else {
				statusClass = 'error';
				statusText  = 'Error';
			}

			const typeTitle = ev.type_title || `Type ID: ${ev.type_id}`;

			// If event type_id == 1, we show a "View Log" link
			let runLog = '';
			if (ev.type_id === 1) {
				runLog = `<a class="link log_link" data-logid="${ev.run_id}">View Log</a>`;
			}

			// Safely escape the notes to avoid breaking HTML
			const safeNotes = ev.notes
				// Step 1: escape everything to avoid raw HTML injection
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;');

// Step 2: specifically un-escape the <br> tags
			const finalNotes = safeNotes.replaceAll('&lt;br&gt;', '<br>');

			const notesHtml = ev.notes
				? `
              <div class="row_line notes-section">
                <a href="#" class="toggle-notes">View Details</a>
                <div class="notes-content" style="display:none;">
                  ${finalNotes}
                </div>
              </div>
            `
				: `
              <div class="row_line">
                <strong>Notes:</strong> (none)
              </div>
            `;

			return `
          <div class="event-block">
            <h4>${typeTitle}</h4>
            <div class="row_line">
              Status: <span class="status ${statusClass}">${statusText}</span>
            </div>
            <div class="row_line">
              Created: <span class="datatime">${ev.created || ''}</span>
            </div>
            ${notesHtml}
            ${runLog}
          </div>
        `;
		})
		.join('');
};

/* ========== 1) Viewing Logs ========== */

export function initDataSourceLogs() {




	// Toggling the notes container
	$(document).on('click', '.toggle-notes', function(e) {
		e.preventDefault();
		const $link         = $(this);
		const $notesContent = $link.closest('.notes-section').find('.notes-content');
		$notesContent.toggle();
		$link.text($notesContent.is(':visible') ? 'Hide Details' : 'View Details');
	});





	// Bind sub-level (Bootstrap) tab show event to update URL hash and fetch logs.
	$(document).on('shown.bs.tab', 'a.nav-link[data-bs-toggle="tab"]', function(e) {
		const $link = $(e.target);
		const subTabId = ($link.attr('href') || '').replace('#',''); // e.g. "driver-report-oem_tab"
		// Assume the top-level is stored in the active .single_tab.
		let top = $('.tabs_wrap .single_tab.active').data('tab') || '';
		top = top.replace('#','');
		let newHash = top ? `${top}/${subTabId}` : subTabId;
		location.hash = newHash;

		// Optionally fetch logs if the sub-tab has a data-source_id.
		const dsId = $link.data('source_id');
		if (dsId) {
			fetchDataSources($link.attr('href'), dsId);
		}
	});


	 return {  buildLogHtml };




}

/* ========== 2) Download Button ========== */

export function initDownloadButton() {
	/**
	 * Clicking a .download-btn:
	 * 1) Checks row count (ETA),
	 * 2) Shows countdown,
	 * 3) Requests the Excel file,
	 * 4) Initiates browser download
	 */
	$(document).on('click', '.download-btn', function(e) {
		e.preventDefault();

		const $btn         = $(this);
		const originalHTML = $btn.html();
		const dataSourceId = $btn.data('id'); // e.g. 123

		if (!dataSourceId) {
			console.error('No data-id on download button.');
			return;
		}

		// Disable to prevent multiple clicks
		$btn.prop('disabled', true).text('Checking rows...');

		// 1) Quick AJAX for row count
		$.ajax({
			url: '/DataSource/get_row_count',
			type: 'POST',
			data: { id: dataSourceId },
			dataType: 'json',
			success: function(response) {
				const rowCount = response.row_count || 0;
				// Example formula for ETA
				let estimatedTimeSec = Math.ceil((rowCount / 1000) * 0.6);
				if (estimatedTimeSec < 1) estimatedTimeSec = 1;

				// Build some UI with the countdown
				const countdownHtml = `
          <div>Found ${rowCount} rows. Generating Excel. Please wait.</div>
          <small class="eta-info">
            <span class="countdown-timer">Remaining: ${estimatedTimeSec}s</span>
          </small>
        `;
				$btn.html(countdownHtml);

				// Start a simple countdown
				let remaining = estimatedTimeSec;
				const intervalId = setInterval(() => {
					remaining--;
					if (remaining <= 0) {
						$('.countdown-timer').text('Finalizing...');
						clearInterval(intervalId);
					} else {
						$('.countdown-timer').text(`Remaining: ${remaining}s`);
					}
				}, 1000);

				// 2) Now actually download the Excel
				$.ajax({
					url: '/DataSource/download_excel',
					type: 'POST',
					data: { id: dataSourceId },
					xhrFields: {
						responseType: 'blob' // expecting a binary file
					},
					success: function(blob, textStatus, xhr) {
						// Extract filename from Content-Disposition or fallback
						let disposition = xhr.getResponseHeader('Content-Disposition');
						let filename    = `data_source_${dataSourceId}.xlsx`;

						if (disposition && disposition.indexOf('filename=') !== -1) {
							const match = disposition.match(/filename="?([^"]+)"?/);
							if (match && match[1]) {
								filename = match[1];
							}
						}

						// Initiate download
						const url  = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href  = url;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
					},
					error: function(xhr, status, error) {
						console.error('Error downloading Excel file:', error);
						$btn.html('<span class="text-danger">Failed to generate Excel file.</span>');
					},
					complete: function() {
						// Stop countdown + restore button after short delay
						clearInterval(intervalId);
						setTimeout(() => {
							$btn.prop('disabled', false).html(originalHTML);
						}, 2000);
					}
				});
			},
			error: function(xhr, status, error) {
				console.error('Error checking row count:', error);
				$btn.html('<span class="text-danger">Failed to retrieve row count.</span>');
				setTimeout(() => {
					$btn.prop('disabled', false).html(originalHTML);
				}, 2000);
			}
		});
	});
}

/* ========== 3) Refresh Button ========== */

export function initRefreshButton() {
	/**
	 * When user clicks .refresh-btn:
	 * 1) We call /DataSource/refresh_now to start a job
	 * 2) We show a countdown
	 * 3) We poll the server until the job is done
	 * 4) Then we fetch logs for the #bam-data_tab
	 */

	$(document).on('click', '.refresh-btn', function(e) {
		e.preventDefault();

		const $btn        = $(this);
		const dataSourceId = $btn.data('id');
		if (!dataSourceId) {
			console.error('No data-id found on refresh button.');
			return;
		}

		$btn.prop('disabled', true).text('Starting refresh...');

		// 1) Start refresh job
		$.ajax({
			url: '/DataSource/refresh_now',
			type: 'POST',
			dataType: 'json',
			data: { id: dataSourceId },
			success: function(response) {
				// Expect { status:'ok', run_id:..., refresh_eta:... }
				if (response.status === 'ok') {
					const runId           = response.run_id;
					let   remaining       = response.refresh_eta || 10;

					$btn.text(`Refreshing... ${remaining}s`);

					// 2) Simple countdown
					const countdownId = setInterval(() => {
						remaining--;
						if (remaining <= 0) {
							clearInterval(countdownId);
							$btn.text('Finalizing...');
						} else {
							$btn.text(`Refreshing... ${remaining}s`);
						}
					}, 1000);

					// 3) Poll the server until it's done
					const pollInterval = setInterval(() => {
						pollRunStatus(runId, () => {
							// The job is done (status != running)
							clearInterval(pollInterval);
							clearInterval(countdownId);

							$btn.text('Finalizing...');

							// Now re-fetch logs for #bam-data_tab
							fetchDataSources('#bam-data_tab', dataSourceId);

							// Re-enable after short delay
							setTimeout(() => {
								$btn.prop('disabled', false).text('Refresh Now');
							}, 2000);
						});
					}, 5000);

				} else {
					console.error('Refresh returned error:', response);
					alert('Failed to start refresh.');
					$btn.prop('disabled', false).text('Refresh Now');
				}
			},
			error: function(xhr, status, error) {
				console.error('Error calling refresh_now:', error);
				alert('Could not start refresh.');
				$btn.prop('disabled', false).text('Refresh Now');
			}
		});
	});

	/**
	 * Poll the server to see if a given runId is still running or finished.
	 * callbackDone() is called once the run is no longer 'running'.
	 */
	function pollRunStatus(runId, callbackDone) {
		$.ajax({
			url: '/DataSource/check_run_status?run_id=' + runId,
			type: 'GET',
			dataType: 'json',
			success: function(resp) {
				if (resp.error) {
					console.warn('pollRunStatus error:', resp.error);
					return;
				}
				// Suppose status_id=2 => running, 1 => success, 0 => error
				if (resp.status_id !== 2) {
					// It's finished or errored
					if (typeof callbackDone === 'function') {
						callbackDone();
					}
				}
			},
			error: function(xhr, status, error) {
				console.error('Poll error:', error);
			}
		});
	}


}


//////////////////////////
// 1) Helpers at module level
//////////////////////////

function renderDataSources(tabSelector, data, data_source_id) {
	const $container = $(tabSelector);

	// 1) Build monthly HTML
	const monthlyHtml = buildLogHtml(data.monthly, data_source_id);
	$container.find('.monthlyUpdates').html(monthlyHtml);

	// 2) Build daily HTML
	const dailyHtml = buildLogHtml(data.daily, data_source_id);
	$container.find('.dailyUpdates').html(dailyHtml);
}

/**
 * Single fetch function for data sources, exported if needed in other files.
 */
export function fetchDataSources(tabSelector, data_source_id) {
	console.error('get-data-source-logs', tabSelector, data_source_id);
	$.ajax({
		url: '/DataSource/get-data-source-logs',
		type: 'POST',
		data: { id: data_source_id },
		dataType: 'json',
		success: function(response) {
			renderDataSources(tabSelector, response, data_source_id);
		},
		error: function(xhr, status, error) {
			console.error('Error fetching data sources logs:', error);
		}
	});
}